const stepKey = (prefix, node, index) => `${prefix}-${node?._id || index}`;

const stepSettled = (key, optimisticCompletedKeys, pendingStepKey) => optimisticCompletedKeys.includes(key) && key !== pendingStepKey;

/** 一组发货或验收节点是否都已完成。进行中的点击不算完成。 */
export const isScheduleGroupDone = (nodes, orderFlag, prefix, optimisticCompletedKeys = [], pendingStepKey = null) => {
	const list = nodes || [];
	const keys = optimisticCompletedKeys || [];
	const recordedDone = list.length > 0 ? list.every((node) => node.isCompleted) || (list.length === 1 && Boolean(orderFlag)) : Boolean(orderFlag);
	const optimisticDone =
		list.length > 0
			? list.every((node, index) => node.isCompleted || stepSettled(stepKey(prefix, node, index), keys, pendingStepKey))
			: stepSettled(`${prefix}-default`, keys, pendingStepKey);
	return recordedDone || optimisticDone;
};

/** 物流完成：发货和每一次验收都完成。 */
export const isLogisticsTimelineComplete = ({ deliveryNodes, acceptNodes, isDelivered, isAccepted, optimisticCompletedKeys, pendingStepKey }) =>
	isScheduleGroupDone(deliveryNodes, isDelivered, 'delivery', optimisticCompletedKeys, pendingStepKey) &&
	isScheduleGroupDone(acceptNodes, isAccepted, 'accept', optimisticCompletedKeys, pendingStepKey);
